import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://metro4.dcairo.com/api';

const NextWeekBreaking = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [weekData, setWeekData] = useState([]);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    fetchWeekData();
  }, []);

  const fetchWeekData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const allData = [];
      
      for (let i = 1; i <= 7; i++) {
        const date = new Date();
        date.setDate(date.getDate() + i);
        const dateStr = date.toISOString().split('T')[0];
        
        const response = await axios.get(`${API_URL}/pours/todays-breaking?date=${dateStr}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data.success && response.data.data.length > 0) {
          allData.push({
            date: dateStr,
            dayNumber: i,
            cubes: response.data.data
          });
        }
      }

      setWeekData(allData);
    } catch (error) {
      console.error('Error fetching week data:', error);
      if (error.response?.status === 401) {
        toast.error('انتهت الجلسة');
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ar-EG', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const formatDateShort = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('en-GB');
  };

  const formatStation = (station) => {
    if (!station) return '-';
    return station.split(' ')[0];
  };

  const getTotalCubes = () => {
    return weekData.reduce((sum, day) => sum + day.cubes.length, 0);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => navigate('/cubes/upcoming')}
              style={{
                background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: '700',
                transition: 'all 0.3s',
                boxShadow: '0 4px 12px rgba(100, 116, 139, 0.3)'
              }}
            >
              ← رجوع
            </button>
            <h1 style={{ margin: 0 }}>📆 تكسير الأسبوع القادم</h1>
          </div>
        </div>

        <div className="dashboard-main">
          <style>{`
            .week-container {
              padding: 20px;
              max-width: 1600px;
              margin: 0 auto;
            }

            .week-summary {
              background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
              color: white;
              padding: 30px;
              border-radius: 16px;
              margin-bottom: 30px;
              box-shadow: 0 8px 30px rgba(139, 92, 246, 0.3);
            }

            .summary-title {
              font-size: 28px;
              font-weight: 800;
              margin: 0 0 20px 0;
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .summary-stats {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 20px;
            }

            .stat-box {
              background: rgba(255, 255, 255, 0.2);
              padding: 15px;
              border-radius: 12px;
              backdrop-filter: blur(10px);
            }

            .stat-label {
              font-size: 14px;
              opacity: 0.9;
              margin-bottom: 5px;
            }

            .stat-value {
              font-size: 32px;
              font-weight: 800;
            }

            .day-section {
              background: white;
              border-radius: 16px;
              padding: 25px;
              margin-bottom: 25px;
              box-shadow: 0 4px 20px rgba(0,0,0,0.08);
            }

            .day-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 20px;
              padding-bottom: 15px;
              border-bottom: 3px solid #8b5cf6;
            }

            .day-title {
              font-size: 24px;
              font-weight: 800;
              color: #1e293b;
              display: flex;
              align-items: center;
              gap: 10px;
            }

            .day-count {
              background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
              color: white;
              padding: 8px 16px;
              border-radius: 20px;
              font-size: 14px;
              font-weight: 700;
            }

            .cubes-table {
              width: 100%;
              border-collapse: collapse;
              overflow: hidden;
              border-radius: 12px;
            }

            .cubes-table thead {
              background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
            }

            .cubes-table th {
              padding: 15px;
              text-align: right;
              font-weight: 800;
              color: #ffffff;
              font-size: 15px;
              border-bottom: 2px solid #8b5cf6;
            }

            .cubes-table td {
              padding: 12px 15px;
              border-bottom: 1px solid #f3e8ff;
              color: #1e293b;
              font-size: 13px;
            }

            .cubes-table tbody tr:hover {
              background: #faf5ff;
            }

            .cubes-table tbody tr:last-child td {
              border-bottom: none;
            }

            .age-badge {
              background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
              color: white;
              padding: 4px 12px;
              border-radius: 12px;
              font-size: 12px;
              font-weight: 700;
              display: inline-block;
            }

            .station-badge {
              background: #eff6ff;
              color: #1e40af;
              padding: 4px 12px;
              border-radius: 12px;
              font-size: 12px;
              font-weight: 700;
              display: inline-block;
            }

            .empty-state {
              text-align: center;
              padding: 80px 20px;
              background: white;
              border-radius: 16px;
            }

            .empty-icon {
              font-size: 80px;
              margin-bottom: 20px;
            }

            .empty-title {
              font-size: 24px;
              font-weight: 700;
              color: #64748b;
              margin: 0 0 10px 0;
            }

            .empty-text {
              font-size: 16px;
              color: #94a3b8;
              margin: 0;
            }

            @media (max-width: 768px) {
              .cubes-table {
                font-size: 12px;
              }

              .cubes-table th,
              .cubes-table td {
                padding: 10px 8px;
              }

              .day-header {
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
              }

              .summary-stats {
                grid-template-columns: 1fr;
              }
            }
          `}</style>

          <div className="week-container">
            {loading ? (
              <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
                <p style={{ fontSize: '18px', color: '#64748b' }}>جاري تحميل بيانات الأسبوع...</p>
              </div>
            ) : weekData.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">✅</div>
                <h2 className="empty-title">لا توجد مكعبات مجدولة</h2>
                <p className="empty-text">لا توجد مكعبات للتكسير في الأسبوع القادم</p>
              </div>
            ) : (
              <>
                <div className="week-summary">
                  <h2 className="summary-title">
                    <span>📊</span>
                    ملخص الأسبوع القادم
                  </h2>
                  <div className="summary-stats">
                    <div className="stat-box">
                      <div className="stat-label">إجمالي المكعبات</div>
                      <div className="stat-value">{getTotalCubes()}</div>
                    </div>
                    <div className="stat-box">
                      <div className="stat-label">عدد الأيام</div>
                      <div className="stat-value">{weekData.length}</div>
                    </div>
                    <div className="stat-box">
                      <div className="stat-label">الفترة</div>
                      <div className="stat-value" style={{ fontSize: '18px' }}>
                        7 أيام قادمة
                      </div>
                    </div>
                  </div>
                </div>

                {weekData.map((day, dayIndex) => (
                  <div key={dayIndex} className="day-section">
                    <div className="day-header">
                      <div>
                        <h3 className="day-title">
                          <span>📅</span>
                          {formatDate(day.date)}
                        </h3>
                        <p style={{ margin: '5px 0 0 35px', color: '#64748b', fontSize: '14px' }}>
                          {formatDateShort(day.date)} - بعد {day.dayNumber} يوم
                        </p>
                      </div>
                      <div className="day-count">
                        {day.cubes.length} مكعب
                      </div>
                    </div>

                    <table className="cubes-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Station</th>
                          <th>Location</th>
                          <th>Mix</th>
                          <th>Cube Age</th>
                          <th>Cubes</th>
                          <th>Casting Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {day.cubes.map((cube, cubeIndex) => (
                          <tr key={cubeIndex}>
                            <td style={{ fontWeight: '700', color: '#8b5cf6' }}>
                              {cubeIndex + 1}
                            </td>
                            <td>
                              <span className="station-badge">{formatStation(cube.station)}</span>
                            </td>
                            <td>{cube.location}</td>
                            <td>{cube.mix}</td>
                            <td>
                              <span className="age-badge">{cube.age}</span>
                            </td>
                            <td style={{ fontWeight: '700', color: '#1e40af', fontSize: '13px' }}>
                              {cube.cubesCount?.groups && cube.cubesCount?.cubesPerGroup 
                                ? `${cube.cubesCount.groups}G × ${cube.cubesCount.cubesPerGroup} = ${cube.cubesCount.total}C`
                                : '-'
                              }
                            </td>
                            <td>{formatDateShort(cube.castingDate)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextWeekBreaking;